import request from '@/utils/request'

// 首页轮播图
export function listSlider(query) {
  return request({
    url: '/website/index/image/slider/list',
    method: 'get',
    params: query
  })
}
// 获取应用场景信息列表
export function listIndexApplication(query) {
  return request({
    url: '/website/index/application/scene/list',
    method: 'get',
    params: query
  })
}
// 查询产品信息列表
export function listIndexProduct(query) {
  return request({
    url: '/website/index/product/list',
    method: 'get',
    params: query
  })
}
// 基础信息
export function indexSet(query) {
  return request({
    url: '/website/index/set',
    method: 'get',
    params: query
  })
}
